import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=1241fa81&"
import script from "./footer-nav.vue?vue&type=script&lang=js&"
export * from "./footer-nav.vue?vue&type=script&lang=js&"
import style0 from "./footer-nav.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports